// Contract Request constants — sync với BE enum CONTRACT_REQUEST_STATUS.
// BE: backend/src/modules/contract-request/constants

export const CONTRACT_REQUEST_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CONTRACT_CREATED: 'contract_created',
  CANCELLED_MANUAL: 'cancelled_manual',
};

export const CONTRACT_REQUEST_STATUS_LABEL = {
  [CONTRACT_REQUEST_STATUS.PENDING]: 'Chờ duyệt',
  [CONTRACT_REQUEST_STATUS.APPROVED]: 'Đã duyệt',
  [CONTRACT_REQUEST_STATUS.REJECTED]: 'Từ chối',
  [CONTRACT_REQUEST_STATUS.CONTRACT_CREATED]: 'Đã tạo HĐ',
  [CONTRACT_REQUEST_STATUS.CANCELLED_MANUAL]: 'Đã hủy',
};

// Vuetify color names
export const CONTRACT_REQUEST_STATUS_COLOR = {
  [CONTRACT_REQUEST_STATUS.PENDING]: 'orange',
  [CONTRACT_REQUEST_STATUS.APPROVED]: 'success',
  [CONTRACT_REQUEST_STATUS.REJECTED]: 'red',
  [CONTRACT_REQUEST_STATUS.CONTRACT_CREATED]: 'primary',
  [CONTRACT_REQUEST_STATUS.CANCELLED_MANUAL]: 'grey',
};

export const CONTRACT_REQUEST_STATUS_OPTIONS = Object.values(
  CONTRACT_REQUEST_STATUS,
).map((value) => ({
  value,
  text: CONTRACT_REQUEST_STATUS_LABEL[value],
}));

export const CUSTOMER_TYPE = {
  CUSTOMER: 'CUSTOMER',
  BUSSINESS: 'BUSSINESS', // BE intentionally typo (legacy enum)
};

export const CUSTOMER_TYPE_OPTIONS = [
  { value: CUSTOMER_TYPE.CUSTOMER, text: 'Cá nhân' },
  { value: CUSTOMER_TYPE.BUSSINESS, text: 'Doanh nghiệp' },
];

export const PAYMENT_TYPE = {
  DIRECTLY: 'DIRECTLY',
  INSTALLMENT: 'INSTALLMENT',
};

export const PAYMENT_TYPE_OPTIONS = [
  { value: PAYMENT_TYPE.DIRECTLY, text: 'Thanh toán trực tiếp' },
  { value: PAYMENT_TYPE.INSTALLMENT, text: 'Trả góp' },
];
